export function normalizeComparablePathname(pathname: string): string {
    if (!pathname) {
        return "/";
    }

    if (pathname === "/") {
        return pathname;
    }

    const normalized = pathname.replace(/\/+$/, "");
    return normalized || "/";
}

export function toComparableLocationKey(url: URL): string {
    return `${normalizeComparablePathname(url.pathname)}${url.search}`;
}

export function isSameRouteNavigation(
    targetHref: string | null | undefined,
    currentHref: string
): boolean {
    if (!targetHref) {
        return false;
    }

    try {
        const currentUrl = new URL(currentHref);
        const targetUrl = new URL(targetHref, currentHref);

        if (targetUrl.origin !== currentUrl.origin) {
            return false;
        }

        return (
            toComparableLocationKey(targetUrl) ===
            toComparableLocationKey(currentUrl)
        );
    } catch {
        return false;
    }
}
